export default "__VITE_ASSET__DN7heC_4__"